import imageDe from '../images/de/tidepool_install.png';
import imageEn from '../images/en/tidepool_install.png';
import imageEs from '../images/es/tidepool_install.png';
import imageFi from '../images/fi/tidepool_install.png';
import imageFr from '../images/fr/tidepool_install.png';
import imageIt from '../images/it/tidepool_install.png';
import imageNo from '../images/no/tidepool_install.png';
import imageSv from '../images/sv/tidepool_install.png';

export const tidepoolInstallImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
